<template>
  <div class="flex flex-col items-center my-20">
    <h4>This is the Customers Page</h4>
    <div v-for="user in users" :key="user.id">
      {{ user.first_name }} {{ user.last_name }} - {{ user.email }}
    </div>
  </div>
</template>

<script>
import { usersApi } from '@listen360/js_api_client'

export default {
  data() {
    return {
      users: [],
      error: {}
    }
  },
  async created() {
    try {
      this.users = await usersApi.query()
    } catch (error) {
      this.error = error
    }
  }
}
</script>
